import { z } from 'zod';
import { ID } from '../../utils/codecUtils';
import { PaginationQuery } from '../../utils/listQuery';
import { listResponse } from '../../utils/listResponse';
import { relationSchema } from '../models/relations.schema';
import { relationListQuerySchema } from './list.schema';

export type RelationListQuery = Partial<{
  id: ID[];
  type: 'export' | 'einvoice';
  annotation: ID[];
  key: string;
  document: ID[];
}> &
  PaginationQuery;

export const list = (query: RelationListQuery = {}) => {
  return {
    endpoint: `/document_relations`,
    method: 'GET',
    responseSchema: listResponse(relationSchema),
    query: { ...query, includeTotal: true },
    querySchema: relationListQuerySchema.and(
      z.object({ includeTotal: z.boolean().optional() })
    ),
  } as const;
};
